/* eslint-disable no-eval */
import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { filter, shareReplay } from 'rxjs/operators';
import { catchError, Observable, tap, withLatestFrom } from 'rxjs';
import {
  LOGGEDINUSER, UserAgentService, User, AppInitializerService, AppService, GtmService, NavigationHelper,
} from '@lc/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'lc-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent {
  private appInitializer = inject(AppInitializerService);
  private gtagService = inject(GtmService);
  private readonly GTAG_MAP = new Map([
    ['prod', 'GTM-TNWHNHJ'],
    ['uat', 'GTM-TWJ36QJ'],
  ]);
  router = inject(Router);

  constructor() {
    const { appInitializer } = this;
    const { router } = this;
    const store = inject<Store<any>>(Store);
    const userAgentService = inject(UserAgentService);

    userAgentService.doBrowserCheck();
    appInitializer.initializeKeys('lc-coordinator-app', AppService.productSuiteName);

    const user$: Observable<User> = store.select(LOGGEDINUSER).pipe(
      filter((user) => !!user?.profile),
      shareReplay(1),
    );
    NavigationHelper.urlChanged$(router)
      .pipe(
        tap((url) => this.appInitializer.refreshNotifications(url)),
        withLatestFrom(user$),
        tap(([url, user]) => {
          // Set the audit date
          const auditCreatedDate = user.profile.audit?.createdAt;
          const setRoundedValueAuditCreatedDate = Math.round(new Date(auditCreatedDate).getTime() / 1000);
          const setRoundNewDateValue = Math.round(new Date().getTime() / 1000);
          const auditCreatedDateTime = auditCreatedDate ? setRoundedValueAuditCreatedDate : setRoundNewDateValue;

          const event = {
            event: 'virtualPageview',
            page_path: url,
            country: 'US',
            userType: 'Coordinator',
            oktaID: user.oktaId,
            personMDMID: user.personMasterId || '',
            companyMDMID: user.profile.office?.company?.companyMasterId || '',
            companyName: user.profile.office?.company?.companyName || '',
            emailAddress: user.profile.preferredEmail || 'email',
            createdAt: auditCreatedDateTime,
          };

          this.gtagService.pushEvent(this.GTAG_MAP, event);
        }),
        catchError((err) => { throw new Error(err); }),
        takeUntilDestroyed(),
      ).subscribe();
  }
}
